import { defineMessages } from 'react-intl'

import { TICKET_INSURANCE_STATUS } from './constants'

export const ticketInsuranceStatusMessages = defineMessages({
  [TICKET_INSURANCE_STATUS.CONFIRMED]: {
    id: 'dictionary.confirmed',
    defaultMessage: 'Confirmed'
  },
  [TICKET_INSURANCE_STATUS.RESERVED]: {
    id: 'dictionary.reserved',
    defaultMessage: 'Reserved'
  },
  [TICKET_INSURANCE_STATUS.CANCELLED]: {
    id: 'dictionary.cancelled',
    defaultMessage: 'Cancelled'
  },
  [TICKET_INSURANCE_STATUS.EXPIRED]: {
    id: 'dictionary.expired',
    defaultMessage: 'Expired'
  },
  [TICKET_INSURANCE_STATUS.FAILED]: {
    id: 'dictionary.failed',
    defaultMessage: 'Failed'
  },
  [TICKET_INSURANCE_STATUS.CREATION_FAILED]: {
    id: 'dictionary.creationFailed',
    defaultMessage: 'Creation failed'
  },
  [TICKET_INSURANCE_STATUS.CANCELLATION_FAILED]: {
    id: 'dictionary.cancellationFailed',
    defaultMessage: 'Cancellation failed'
  },
  [TICKET_INSURANCE_STATUS.EDIT_FAILED]: {
    id: 'dictionary.editFailed',
    defaultMessage: 'Edit failed'
  },
  [TICKET_INSURANCE_STATUS.PARTIALLY_CANCELLED]: {
    id: 'dictionary.partiallyCancelled',
    defaultMessage: 'Partially cancelled'
  }
})
